import rg4js from 'raygun4js';

import myFetch from './myFetch';

const servicesFactory = myFetch => ({
  saveWaiver: isSigned => {
    const url = `${process.env.REACT_APP_BASE_API_URL}/user/WaiverSigned`;
    return myFetch({ method: 'post', url, data: { isSigned } });
  },
  saveAvatar: base64Image => {
    const url = `${process.env.REACT_APP_BASE_API_URL}/user/avatar`;
    return myFetch({ method: 'put', url, data: { base64Image } });
  },
  addCard: (token, brand, last4, expirationMonth, expirationYear) => {
    const url = `${process.env.REACT_APP_BASE_API_URL}/stripe/AddCard`;
    return myFetch({
      method: 'post',
      url,
      data: { token, brand, last4, expirationYear, expirationMonth }
    });
  },
  deleteCard: id => {
    const url = `${process.env.REACT_APP_BASE_API_URL}/stripe/RemoveCard`;
    return myFetch({
      method: 'post',
      url,
      data: { id }
    });
  },
  getProfile: () => {
    const url = `${process.env.REACT_APP_BASE_API_URL}/user/get`;
    return myFetch({ method: 'get', url });
  },
  saveProfile: profile => {
    const url = `${process.env.REACT_APP_BASE_API_URL}/user/UpdateUser`;
    return myFetch({ method: 'post', url, data: profile });
  },
  signUpUser: profile => {
    const url = `${process.env.REACT_APP_BASE_API_URL}/user/Signup`;
    return myFetch({ method: 'post', url, data: profile });
  },
  setRaygunUser: user => {
    rg4js('setUser', {
      identifier: user.Id,
      isAnonymous: false,
      email: user.Email,
      fullName: `${user.FirstName} ${user.LastName}`
    });
  },
  getStates: () => {
    const url = `${
      process.env.REACT_APP_BASE_API_URL
    }/state/CountryCode?CountryCode=US`;
    return myFetch({ method: 'get', url });
  },
  setDefaultCard: CardId => {
    const url = `${
      process.env.REACT_APP_BASE_API_URL
    }/stripe/ChangeDefaultCard`;
    return myFetch({ method: 'post', url, data: { CardId } });
  },
  cancelMembership: (cancelreason, SubscriptionId) => {
    const url = `${
      process.env.REACT_APP_BASE_API_URL
    }/stripe/CancelSubscription`;
    return myFetch({
      method: 'post',
      url,
      data: { cancelreason, SubscriptionId }
    });
  },
  getUserByEmail: email => {
    const url = `${process.env.REACT_APP_BASE_API_URL}/user/GetUserByEmail`;
    return myFetch({
      method: 'get',
      url,
      params: { email }
    });
  },
  setSignUpStep: SignupStep => {
    const url = `${process.env.REACT_APP_BASE_API_URL}/user/UpdateSignupStep`;
    return myFetch({
      method: 'put',
      url,
      data: { SignupStep }
    });
  },
  getPeopleVineRedirectInfo: () => {
    const url = `${
      process.env.REACT_APP_BASE_API_URL
    }/user/GetPeopleVineUserPassword`;
    return myFetch({
      method: 'get',
      url
    });
  },
  postPeopleVineInfo: () => {
    const url = `${process.env.REACT_APP_BASE_API_URL}/user/PostToPeopleVine`;
    return myFetch({
      method: 'post',
      url
    });
  }
});

const services = servicesFactory(myFetch);

export default services;



// WEBPACK FOOTER //
// ./src/utils/services.js